import { oz } from '@weft/utils';
import { RevenuePerMonthSchema } from './revenue-per-month-schema';

export const YearlyRevenueSchema = oz.record(oz.string().or(oz.number()), RevenuePerMonthSchema);

export type YearlyRevenue = oz.infer<typeof YearlyRevenueSchema>;